import {
  changePassword,
  forgotPassword,
  updatePassword
} from "./chunk-5DW6DKSR.mjs";

// src/hooks/wbk/auth/password.ts
import { useMutation } from "@tanstack/react-query";
var useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword
  });
};
var useChangePassword = () => {
  return useMutation({
    mutationFn: changePassword
  });
};
var useUpdatePassword = () => {
  return useMutation({
    mutationFn: updatePassword
  });
};

export {
  useForgotPassword,
  useChangePassword,
  useUpdatePassword
};
//# sourceMappingURL=chunk-NE6F5GH7.mjs.map